export enum EnumLocalStorageKeys {
    token = 'token'
}